import {
  ArrowRight,
  Email,
  Language,
  Looks4,
  Looks5,
  LooksOne,
  LooksTwo,
  PhoneEnabled,
} from '@mui/icons-material'
import { Alert, Box, Divider, Grid, Link, Typography } from '@mui/material'
import BaseLayout from 'layouts/Base/BaseLayout'

export function ContactPage() {
  return (
    <BaseLayout
      pageTitle="Get in touch via telephone, email or via the form below."
      mainElement={
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={12} md={6}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                borderRadius: '8px',
                backgroundColor: '#fff',
                boxShadow: 2,
                minHeight: '30dvh',
                padding: '20px',
                gap: '20px',
                fontFamily: (theme) => theme.typography.fontFamily,
              }}
            >
              <Typography variant="h6">Feedback</Typography>
              <Box sx={{ display: 'flex' }}>
                <Typography sx={{ fontSize: '18px' }}>
                  <p>
                    To provide feedback on a ride, please{' '}
                    <Link
                      href="https://bit.ly/4nPxAYT"
                      sx={{
                        color: 'inherit',
                        fontWeight: 500,
                        textDecoration: 'underline',
                      }}
                    >
                      leave your comments here
                    </Link>
                    .
                  </p>
                  <p>Your feedback goes straight to the right team. </p>
                  <p>
                    We’ll reply within 1 working day, and aim to resolve
                    everything within 7 working days.
                  </p>
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',

                  justifyItems: 'center',
                  alignItems: 'flex-start',
                  flexDirection: 'row',
                  gap: '50px',
                }}
              >
                <Box sx={{ display: 'flex', minWidth: '50%' }}>
                  <Box>
                    <Typography variant="h6">
                      Booking & General Enquiries
                    </Typography>
                    <Divider sx={{ marginBottom: '20px' }} />
                    <Box
                      sx={{ display: 'flex', gap: '15px', alignItems: 'start' }}
                    >
                      <Box>
                        <Typography>
                          <Link
                            href={`tel:+443450042099`}
                            style={{
                              color: 'inherit',
                              fontWeight: 500,
                            }}
                            sx={{
                              display: 'flex',
                              gap: '7px',
                              textWrap: 'nowrap',
                            }}
                          >
                            <PhoneEnabled />
                            +44 345 004 2099
                          </Link>
                        </Typography>
                        <Typography>
                          <Link
                            href={`tel:+442039258861`}
                            style={{
                              color: 'inherit',
                              fontWeight: 500,
                            }}
                            sx={{
                              display: 'flex',
                              gap: '7px',
                              textWrap: 'nowrap',
                            }}
                          >
                            <Language />
                            +44 203 925 8861
                          </Link>
                          <Typography
                            fontSize="x-small"
                            sx={{ justifySelf: 'flex-end' }}
                          >
                            (if calling from outside the UK)
                          </Typography>
                        </Typography>
                      </Box>
                      <Box>
                        <ArrowRight />
                      </Box>
                      <Box>
                        <Box>
                          <Typography
                            sx={{
                              display: 'flex',
                              gap: '7px',
                              textWrap: 'nowrap',
                            }}
                          >
                            <LooksOne />
                            Future Bookings
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              display: 'flex',
                              gap: '7px',
                              textWrap: 'nowrap',
                            }}
                          >
                            <LooksTwo />
                            Past Bookings
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              display: 'flex',
                              gap: '7px',
                              textWrap: 'nowrap',
                            }}
                          >
                            <Looks4 />
                            Sales
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box>
                <Typography>
                  <Link
                    href={`mailto:clientservices@jyrney.com`}
                    sx={{
                      display: 'flex',
                      gap: '7px',
                      textWrap: 'nowrap',
                      color: 'inherit',
                      fontWeight: 500,
                      '&:hover': {
                        textDecoration: 'underline',
                        color: 'inherit',
                      },
                    }}
                  >
                    <Email />
                    clientservices@jyrney.com
                  </Link>
                </Typography>
              </Box>

              <Box
                sx={{
                  display: 'flex',

                  justifyItems: 'center',
                  alignItems: 'flex-start',
                  flexDirection: 'row',
                  gap: '50px',
                }}
              >
                <Box sx={{ display: 'flex', minWidth: '70%' }}>
                  <Box>
                    <Typography variant="h6">Client Invoice Queries</Typography>
                    <Divider sx={{ marginBottom: '20px' }} />
                    <Box
                      sx={{ display: 'flex', gap: '15px', alignItems: 'start' }}
                    >
                      <Box>
                        <Typography>
                          <Link
                            href={`tel:+443450042099`}
                            style={{
                              color: 'inherit',
                              fontWeight: 500,
                            }}
                            sx={{
                              display: 'flex',
                              gap: '7px',
                              textWrap: 'nowrap',
                            }}
                          >
                            <PhoneEnabled />
                            +44 345 004 2099
                          </Link>
                        </Typography>
                        <Typography>
                          <Link
                            href={`tel:+442039258861`}
                            style={{
                              color: 'inherit',
                              fontWeight: 500,
                            }}
                            sx={{
                              display: 'flex',
                              gap: '7px',
                              textWrap: 'nowrap',
                            }}
                          >
                            <Language />
                            +44 203 925 8861
                          </Link>
                          <Typography
                            fontSize="x-small"
                            sx={{ justifySelf: 'flex-end' }}
                          >
                            (if calling from outside the UK)
                          </Typography>
                        </Typography>
                      </Box>
                      <Box>
                        <ArrowRight />
                      </Box>
                      <Box>
                        <Box>
                          <Typography
                            sx={{
                              display: 'flex',
                              gap: '7px',
                              textWrap: 'nowrap',
                            }}
                          >
                            <Looks5 />
                            Invoicing / Finance
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box>
                <Typography>
                  <Link
                    href={`mailto:accounts@jyrney.com`}
                    sx={{
                      display: 'flex',
                      gap: '7px',
                      textWrap: 'nowrap',
                      color: 'inherit',
                      fontWeight: 500,
                      '&:hover': {
                        textDecoration: 'underline',
                        color: 'inherit',
                      },
                    }}
                  >
                    <Email />
                    accounts@jyrney.com
                  </Link>
                </Typography>
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  justifyItems: 'center',
                  alignItems: 'flex-start',
                  gap: '10px',
                  flexDirection: 'column',
                }}
              >
                <Typography variant="h6">Supplier Queries</Typography>
                <Box sx={{ minWidth: '60%' }}>
                  <Divider sx={{ marginBottom: '20px' }} />
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    General Enquiries
                    <Typography>
                      <Link
                        href={`mailto:suppliers@jyrney.com`}
                        sx={{
                          display: 'flex',
                          gap: '7px',
                          textWrap: 'nowrap',
                          color: 'inherit',
                          fontWeight: 500,
                          '&:hover': {
                            textDecoration: 'underline',
                            color: 'inherit',
                          },
                        }}
                      >
                        <Email />
                        suppliers@jyrney.com
                      </Link>
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    Invoice Queries
                    <Typography sx={{ display: 'flex', gap: '15px' }}>
                      <Link
                        href={`mailto:invoiceprocessing@jyrney.com`}
                        sx={{
                          display: 'flex',
                          gap: '7px',
                          textWrap: 'nowrap',
                          color: 'inherit',
                          fontWeight: 500,
                          '&:hover': {
                            textDecoration: 'underline',
                            color: 'inherit',
                          },
                        }}
                      >
                        <Email />
                        invoiceprocessing@jyrney.com
                      </Link>
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Alert severity="info" sx={{ marginTop: '20px' }}>
                Emails may take longer to process.
              </Alert>
            </Box>
          </Grid>
        </Grid>
      }
    />
  )
}
